<template>
    <div>
        <Table :no-data-text="$t('common.noData')" :columns="columns" :data="tableCommandHistoryDate" style="width: 100.1%;" height="500" :loading="commandHistoryLoadings">
            <template slot-scope="{row,index}" slot="detail">
                <Button type="info" size="small" @click="rowClick(row)">{{ $t('alarms.common.details') }}</Button>
                <!-- <Button type="warning" size="small"  @click="returnCommandsModal = true">重新运行命令</Button> -->
            </template>
        </Table>

        <!-- 重新运行命令 -->
        <Modal v-model="returnCommandsModal" width="450" :mask-closable="false" :styles="{top:'200px'}">
            <p slot="header" style="color:#f90;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>{{ $t('patch_management.patch_command.rerunCommand') }}</span>
            </p>
            <div style="text-align: center;">
                <p>{{ $t('patch_management.patch_command.rerunCommandContent') }}</p>
                <p>{{ $t('patch_management.patch_command.rerunCommandId') }}</p>
            </div>
            <div slot="footer">
                <Button type="warning" size="large" long :loading="modal_loadings" :disabled="isDisables" @click="returnCommands()">{{ $t('patch_management.patch_command.rerunCommand') }}</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
    var tableCommandHistoryVue = {};
    export default {
        name: 'TableCommandHistory',
        data () {
            return {
                accountIdSearchKey:'',
                regionSearchKey:'',
                commandId:'',
                commandHistoryLoadings:false,
                modal_loadings:false,
                isDisables: false,
                returnCommandsModal:false, //重新运行命令
                columns: [
                    {
                        title: this.$t('PatchEasy.PatchCmd.cmdID'),
                        key: 'commandId'
                    },
                    {
                        title: this.$t('alarms.common.status'),
                        key: 'status'
                    },
                    {
                        title: this.$t('PatchEasy.PatchCmd.requestDate'),
                        key: 'requestedDateTime'
                    },
                    {
                        title: this.$t('PatchEasy.PatchCmd.fileName'),
                        key: 'documentName'
                    },
                    {
                        title: this.$t('PatchEasy.PatchCmd.comment'),
                        key: 'comment'
                    },
                    {
                        title: this.$t('PatchEasy.PatchCmd.tgt'),
                        key: 'targetCount'
                    },
                    {
                        title: this.$t('PatchEasy.PatchCmd.error'),
                        key: 'errorCount'
                    },
                    {
                        title: this.$t('PatchEasy.PatchCmd.submitDelay'),
                        key: 'deliveryTimedOutCount'
                    },
                    {
                        title: this.$t('PatchEasy.PatchCmd.complete'),
                        key: 'completedCount'
                    },
                    {
                        title: this.$t('common.operation'),
                        slot: 'detail'
                    }
                ],
                tableCommandHistoryDate:[]
            }
        },
        beforeCreate: function() {
            tableCommandHistoryVue = this
        },
        methods: {
            showAll: function(accountIdSearchKey,regionSearchKey,commandId){
                tableCommandHistoryVue.accountIdSearchKey = accountIdSearchKey;
                tableCommandHistoryVue.regionSearchKey = regionSearchKey;
                tableCommandHistoryVue.commandId = commandId;
                tableCommandHistoryVue.getCommandHistoryData();
            },
            // 分页显示数据
            /****************************************************/
            getCommandHistoryData:function() {
                this.commandHistoryLoadings = true;
                //分页
                this.$api.policy.listHistoryCommands({
                    "awssmCommandRequestDTO" : {
                        "maxResults" : 50,
                        "executionStage" : "Complete",
                        "commandId" : tableCommandHistoryVue.commandId
                    },
                    "accountId" : tableCommandHistoryVue.accountIdSearchKey,
                    "regionString" : tableCommandHistoryVue.regionSearchKey
                })
                .then(res => {
                    this.tableCommandHistoryDate = res.data;
                    this.commandHistoryLoadings = false;
                });
            },
            /**********************************详情***********************************/
            rowClick:function(row){
                //分页
                this.$api.policy.getCommandDetail({
                    "awssmCommandRequestDTO" : {
                        "maxResults" : 50,
                        "executionStage" : "Complete",
                        "commandId" : row.commandId,
                        "deatils" : true
                    },
                    "accountId" : tableCommandHistoryVue.accountIdSearchKey,
                    "regionString" : tableCommandHistoryVue.regionSearchKey                 
                })
                .then(res => {
                    let $params = {
                        commandId: res.data.commandId,
                        commandStatusDTOs:res.data.commandStatusDTOs,
                        commandTargetsAndOutputsDTOs: res.data.commandTargetsAndOutputsDTOs,
                        documentName: res.data.documentName,
                        comment: res.data.comment,
                        documentVersion: res.data.documentVersion,
                        requestedDateTime: res.data.requestedDateTime,
                        accountIdSearchKey:tableCommandHistoryVue.accountIdSearchKey,
                        regionSearchKey:tableCommandHistoryVue.regionSearchKey,
                        commandParametersDTO:res.data.commandParametersDTO
                        // allowDowngrade:res.data.commandParametersDTO.allowDowngrade[0],
                        // version:res.data.commandParametersDTO.version[0]
                    }
                    
                    this.$router.push({path:'/patchManagement/commandHistoryDetail',query: $params});
                });
            },
            /**********************************重新运行命令***********************************/
            returnCommands: function(){
                this.isDisables = true;  //开始可以点击
                var lineIndex=this.lineIndex;
                //重新运行命令
                this.$api.alertRule.deleteAlertRule("id",this.tableCommandHistoryDate[lineIndex].id)
                .then(res => {
                    this.modal_loadings = true;
                    setTimeout(() => {
                        // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
                        //21条  3页  2*10+1时删除
                        if(lineIndex==0&&((this.current-1)*this.pageSize+1)==this.dataTotal){
                            this.current=this.current-1;
                        }
                        this.dataTotal=this.dataTotal-1;
                        tableCommandHistoryVue.getCommandHistoryData();
                        this.isDisables = false;
                        this.modal_loadings = false;
                        this.returnCommandsModal = false;
                        this.$Message.success(this.$t('patch_management.patch_command.rerunCommandSuccess'));
                    }, 1000);
                })
            }
        }
    }
</script>
<style scoped>
    .ivu-page
    {
        margin-top: 10px !important;
        margin-bottom: 30px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/patch_management/patch_command_parameters/TableCommandHistory.vue